exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-style {\n  font-size: 16px; }\n  .table-style tbody tr:hover {\n    background-color: #fbb034 !important; }\n  .pointer {\n  cursor: pointer;\n  vertical-align: top; }\n  .pointer-default {\n  cursor: default;\n  vertical-align: top; }\n  ::ng-deep .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody > table > tbody > tr > td.dataTables_empty {\n  text-align: center !important; }\n  .contact-bottom {\n  margin-bottom: -0.75rem; }\n  .contact-print {\n  zoom: 90%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/contact-table/contact-table.component.scss
// module id = ../../../../../src/app/crm/contact-table/contact-table.component.scss
// module chunks = main